import * as Immutable from 'seamless-immutable';
import {
  FETCH_RFI_CUSTOM_IDENTIFIER_START,
  FETCH_RFI_CUSTOM_IDENTIFIER_API_FULFILLED,
  FETCH_RFI_CUSTOM_IDENTIFIER_API_REJECTED,
  VALIDATE_RFI_CUSTOM_IDENTIFIER_START,
  VALIDATE_RFI_CUSTOM_IDENTIFIER_API_FULFILLED,
  VALIDATE_RFI_CUSTOM_IDENTIFIER_API_REJECTED,
  SHOW_NEW_ISSUE_MODAL,
  RESET_RFI_CUSTOM_IDENTIFIER_VALIDITY,
  UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_IS_EDITED,
  UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_NEXT_SUGGESTION_CLICKED,
  ISSUE_TRANSITION_POPUP_CHANGE,
  PREVIEW_ISSUE_ID_SET,
} from '../actions';

const initialState = Immutable.from({
  isFetching: false,
  isValidating: false,
  isValid: true,
  showValidationErrorMessage: false,
  showValidationErrorMessageLink: false,
  suggestedNextCustomIdentifier: null,
  // analyticsData holds the data collected in a full cycle of one of the following processes:
  // 1. Creating RFI in status open
  // 2. Transition to status open
  // 3. Editing RFI custom identifier
  // This data should reset upon every cycle end
  analyticsData: {
    isEdited: false,
    nextAvailableNumberClickedCount: 0,
    validationErrorShownCount: 0,
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    // Reducer data should reset when
    // 1. New issue modal is closed/opened
    // 2. Issue transition modal is closed/opened
    // 3. Issue preview modal is closed/opened
    case PREVIEW_ISSUE_ID_SET:
    case ISSUE_TRANSITION_POPUP_CHANGE:
    case SHOW_NEW_ISSUE_MODAL:
      return state.merge(initialState);
    case FETCH_RFI_CUSTOM_IDENTIFIER_START:
      return state.merge({
        isFetching: true,
      });
    case VALIDATE_RFI_CUSTOM_IDENTIFIER_START:
      return state.merge({
        isValidating: true,
        isValid: false,
      });
    case FETCH_RFI_CUSTOM_IDENTIFIER_API_FULFILLED:
      return state.merge({
        isFetching: false,
        showValidationErrorMessage: false,
        showValidationErrorMessageLink: false,
        isValid: true,
        suggestedNextCustomIdentifier: action.payload.suggestedNextCustomIdentifier,
      });
    case VALIDATE_RFI_CUSTOM_IDENTIFIER_API_FULFILLED: {
      const isValid = action.payload.isValid && !action.payload.isTaken;
      if (!isValid) {
        const newCount = state.analyticsData.validationErrorShownCount + 1;
        state = Immutable.setIn(state, ['analyticsData', 'validationErrorShownCount'], newCount);
      }
      return state.merge({
        isValidating: false,
        showValidationErrorMessage: !isValid,
        showValidationErrorMessageLink: !isValid && action.payload.suggestedNextCustomIdentifier !== '',
        isValid,
        suggestedNextCustomIdentifier: action.payload.suggestedNextCustomIdentifier,
      });
    }
    case FETCH_RFI_CUSTOM_IDENTIFIER_API_REJECTED:
      return state.merge({ isFetching: false });
    case VALIDATE_RFI_CUSTOM_IDENTIFIER_API_REJECTED:
      return state.merge({ isValidating: false });
    case RESET_RFI_CUSTOM_IDENTIFIER_VALIDITY:
      return state.merge({ showValidationErrorMessage: false, showValidationErrorMessageLink: false, isValid: true });
    case UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_IS_EDITED: {
      state = Immutable.setIn(state, ['analyticsData', 'isEdited'], true);
      return state;
    }
    case UPDATE_RFI_CUSTOM_IDENTIFIER_ANALYTICS_NEXT_SUGGESTION_CLICKED: {
      const newCount = state.analyticsData.nextAvailableNumberClickedCount + 1;
      return Immutable.setIn(state, ['analyticsData', 'nextAvailableNumberClickedCount'], newCount);
    }

    default:
      return state;
  }
};
